// extracted by mini-css-extract-plugin
export default {"header":"ReportsHeader_header__flV06","dashboardTop":"ReportsHeader_dashboardTop__m8CP7"};